// extracted by mini-css-extract-plugin
export var header = "_vj-1";
export var maskBottom = "_vj-6";
export var maskMiddle = "_vj-7";
export var maskTop = "_vj-5";
export var root = "_vj-0";
export var scrollDownButton = "_vj-3";
export var scrollDownButtonHidden = "_vj-4";
export var viewport = "_vj-2";